import OverviewComponent from "~/components/client/overview";
import PageMeta from "~/components/common/meta";

export function Overview() {
  return (
    <>
      <PageMeta title={`Overview | Art Handler`} />
      <OverviewComponent />
    </>
  );
}
